export enum ROLE {
  ADMIN = "ROLE_ADMIN",
  VOCERO = "ROLE_VOCERO",
  DISENO = "ROLE_DISENO",
  // VIEW = "ROLE_VIEW",
}